import { createFileRoute, lazyRouteComponent, notFound } from "@tanstack/react-router";
import { ENABLE_APPEALS } from "shared/SharedConstants";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getAppealsPageData } from "src/server/functions/Portal";

// Beta: disabled builds fold ENABLE_APPEALS to false and don't ship the page's chunk.
const AppealsPage = ENABLE_APPEALS
  ? lazyRouteComponent(() => import("src/components/app/Appeals/AppealsPage"))
  : () => null;

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/appeals")({
  // The page is already a lazy chunk; a second split by TanStack would load it after hydration
  // (see design-system.tsx). AppealsRoute.preload below loads it before hydration instead.
  codeSplitGroupings: [],
  beforeLoad: () => {
    if (!ENABLE_APPEALS) throw notFound();
  },
  loader: projectLoader((projectId) => getAppealsPageData({ data: projectId })),
  component: AppealsRoute,
});

function AppealsRoute() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <AppealsPage initialProjectId={data?.projectId} initialPage={data?.initialPage} />}
    </DeferredLoaderData>
  );
}
// Hydration waits for the route component's preload, so it renders the page as the server did.
AppealsRoute.preload = "preload" in AppealsPage ? AppealsPage.preload : undefined;
